import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';

import { DynamicGridField, DynamicGridComponentConfig } from 'app/shared/components/dynamic-grid/dynamic-grid.component';
import { SmartModalService, ModalSize } from 'app/core/services/smart-modal.service';
import { NotificationService } from 'app/core/services/notification.service';
import { SessionService } from 'app/core/services/session.service';
import { OrderDetailsComponent } from '../../order-details/order-details.component';
import { ApprovalsService } from '../../approvals.service';
import { ApprovalGroupDetailsComponent } from '../../approval-group-details/approval-group-details.component';
import { RejectPaymentComponent } from '../reject-payment/reject-payment.component';
import { ApprovePaymentComponent } from '../approve-payment/approve-payment.component';

@Component({
    selector: 'itpx-awaiting-approval-transactions-grid',
    templateUrl: 'awaiting-approval-transactions-grid.component.html',
    styleUrls: ['awaiting-approval-transactions-grid.component.css'],
})
export class AwaitingApprovalTransactionsGridComponent {

    @Input() set refresh(_: never) {
        this.refresh$.next();
    }

    @Output() refreshAll: EventEmitter<never> = new EventEmitter();

    refresh$ = new Subject<never>();
    fetchUrl: string;
    config: DynamicGridComponentConfig = {
        useDollarPrefixConvention: true,
        clearTitle: 'Clear filters',
        emptyMessageKey: 'organization.approvals.no-pending-approvals'
    };
    fields: DynamicGridField[] = [
        {
            title: 'Order ID',
            config: {
                type: 'template',
                template: 'orderTemplate',
            },
        },
        {
            title: 'Total',
            name: (item) => {
                return item.currency ? item.currency + ' ' + item.netAmount : '';
            }
        },
        {
            title: 'Ordered By',
            name: 'userId'
        },
        {
            title: 'Approval Pending By',
            config: {
                type: 'template',
                template: 'approvalGroupDetails',
            },
        },
        {
            title: 'Actions',
            config: {
                type: 'template',
                template: 'actions',
            },
        },
    ];

    constructor(
        private approvalsService: ApprovalsService,
        private smartModalService: SmartModalService,
        private notificationService: NotificationService,
        private sessionService: SessionService
    ) { }

    ngOnInit(): void {
        this.fetchUrl = this.approvalsService.getTransactionApprovalRequestsByStatusUrl() + '?status=order-pending-approval&$createdAt=0';
    }

    showOrderDetails(item) {
        this.smartModalService
            .open(
                OrderDetailsComponent,
                {
                    pendingApproval: item
                },
                'Order Details',
                ModalSize.Custom,
            )
            .neverError()
            .subscribe();
    }

    hasActionsPermission(item): boolean {
        const username: string = this.sessionService.getUserDetails().username;
        if (username && item) {
            return (item.approvalPolicy && item.approvalPolicy.approvalGroupMembers) ? !!item.approvalPolicy.approvalGroupMembers.filter(_ => _.email === username ).length
        : false;
        }

        return false;
    }

    showApprovalGroupDetails(item) {
        this.smartModalService
            .open(
                ApprovalGroupDetailsComponent,
                {
                    approvalGroupMembers: item.approvalPolicy.approvalGroupMembers
                },
                'Approval Group',
                ModalSize.Custom,
            )
            .neverError()
            .subscribe();
    }

    reject(item) {
        this.smartModalService
            .open(
                RejectPaymentComponent,
                {
                    pendingApproval: item
                },
                'Reject Order?',
                ModalSize.Custom,
            )
            .neverError()
            .switchMap((res) => {
                const payload = {
                    id: item.approvalPolicy.id,
                    rejectionReason: res.result.rejectionReason
                };
                return this.approvalsService.rejectPayment(item.id, payload)
            })
            .subscribe(
                (_) => {
                    this.notificationService.success('Order is rejected.');
                    this.refreshAll.emit();
                },
                (err) => {
                    this.notificationService.error(err.message, 'Failed');
                }
            );
    }

    approve(item) {
        this.smartModalService
            .open(
                ApprovePaymentComponent,
                {
                    pendingApproval: item
                },
                'Approve Order?',
                ModalSize.Custom,
            )
            .neverError()
            .switchMap(() =>
                this.approvalsService.approvePayment(item.id)
            )
            .subscribe(
                (_) => {
                    this.notificationService.success('Order is approved.');
                    this.refreshAll.emit();
                },
                (err) => {
                    this.notificationService.error(err.message, 'Failed');
                }
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/approvals/transacion-aprovals/awaiting-approval-transactions-grid/awaiting-approval-transactions-grid.component.ts